import React from "react";
import PropTypes from "prop-types";
import { getFrequencyStyle, getTotalFrequencyStyle } from "../../helpers";
import {
  getAlleleFrequency,
  getAlleleValue,
} from "../../../../../../../common/helpers/helpers";
import PopulationFrequenciesTotalTableRow from "./PopulationFrequenciesTotalTableRow";

const calculateAlleleValues = (it, gender) => {
  const alleleNumber = getAlleleValue(it, "an", gender);
  const alleleCount = getAlleleValue(it, "ac", gender);
  const homozygotes = getAlleleValue(it, "nhomalt", gender);
  const alleleFrequencyStyle = getFrequencyStyle(alleleCount, alleleNumber);

  const alleleFrequency =
    alleleCount && alleleNumber
      ? getAlleleFrequency(
          alleleCount / alleleNumber,
          3,
          alleleFrequencyStyle.color,
          alleleFrequencyStyle.weight
        )
      : null;

  return {
    alleleNumber,
    alleleCount,
    homozygotes,
    alleleFrequencyStyle,
    alleleFrequency,
  };
};

const PopulationFrequenciesTotalTable = ({ item, isMito }) => {
  const totalFrequencyStyle = getTotalFrequencyStyle(item.af);
  const totalHomozygotes = isMito ? item.ac_hom : item.nhomalt;
  const totalHeteroplasmic = isMito ? item.ac_het : ""; // exists only for mitochondrial variants (chrM)
  const maleValues = calculateAlleleValues(item, "male");
  const femaleValues = calculateAlleleValues(item, "female");
  const {
    alleleNumber: maleAlleleNumber,
    alleleCount: maleAlleleCount,
    homozygotes: maleHomozygotes,
    alleleFrequency: maleAlleleFrequency,
  } = maleValues;
  const {
    alleleNumber: femaleAlleleNumber,
    alleleCount: femaleAlleleCount,
    homozygotes: femaleHomozygotes,
    alleleFrequency: femaleAlleleFrequency,
  } = femaleValues;

  return (
    <tbody key="totals_tbody">
      <PopulationFrequenciesTotalTableRow
        rowLabel="Total"
        emptyColumn={null}
        alleleCount={item.ac}
        alleleNumber={item.an}
        heteroplasmic={isMito ? totalHeteroplasmic || "-" : null} // exists only for mitochondrial variants (chrM)
        homozygotes={totalHomozygotes}
        hemizygotes={item?.nonpar === 1 ? maleAlleleCount : null} // exists only for chrX and chrY variants
        alleleFrequency={getAlleleFrequency(
          item.af,
          3,
          totalFrequencyStyle.color,
          totalFrequencyStyle.weight
        )}
      />
      {item.an_male != null && (
        <PopulationFrequenciesTotalTableRow
          rowLabel="XY"
          emptyColumn={null}
          alleleCount={maleAlleleCount}
          alleleNumber={maleAlleleNumber}
          heteroplasmic={null}
          homozygotes={maleHomozygotes}
          hemizygotes={item?.nonpar === 1 ? maleAlleleCount : null} // exists only for chrX and chrY variants
          alleleFrequency={maleAlleleFrequency || "-"}
        />
      )}
      {item.an_female != null && (
        <PopulationFrequenciesTotalTableRow
          rowLabel="XX"
          emptyColumn={null}
          alleleCount={femaleAlleleCount}
          alleleNumber={femaleAlleleNumber}
          heteroplasmic={null}
          homozygotes={femaleHomozygotes}
          hemizygotes={item?.nonpar === 1 ? "0" : null} // exists only for chrX and chrY variants
          alleleFrequency={femaleAlleleFrequency || "-"}
        />
      )}
    </tbody>
  );
};

PopulationFrequenciesTotalTable.propTypes = {
  item: PropTypes.shape({
    nonpar: PropTypes.number,
    an_female: PropTypes.number,
    an_male: PropTypes.number,
    ac: PropTypes.number,
    af: PropTypes.number,
    an: PropTypes.number,
    ac_hom: PropTypes.number,
    ac_het: PropTypes.number,
    nhomalt: PropTypes.number,
  }),
  isMito: PropTypes.bool,
};

PopulationFrequenciesTotalTable.defaultProps = {
  item: {},
  isMito: false,
};

export default PopulationFrequenciesTotalTable;
